<template>
    <div class="form-box mb10">
        <el-form inline :model="formData" size="mini" ref="formInline"  @submit.native.prevent="handleOnSubmit">

            <el-form-item prop="delivery_scene">
                <CustomInput label='任务ID'>
                    <el-input clearable  style="width:140px" placeholder="请输入关键字搜索" v-model.trim="formData.task_id" @keyup.enter.native="handleOnSubmit"></el-input>
                </CustomInput>
            </el-form-item>

            <el-form-item prop="production_status">
                <CustomInput label='操作内容'>
                    <el-input clearable  style="width:140px" placeholder="请输入关键字搜索" v-model.trim="formData.operation_items" @keyup.enter.native="handleOnSubmit"></el-input>
                </CustomInput>
            </el-form-item>

            <el-form-item prop="plat_id">
                <CustomInput label='媒体'>
                    <SelectAll :options="defaultOptions['plat']"  v-model="formData.plat_id"/>
                </CustomInput>
            </el-form-item>

            <el-form-item prop="operation_level">
                <CustomInput label='操作层级'>
                    <SelectAll :options="defaultOptions['operation_level']"  v-model="formData.operation_level"/>
                </CustomInput>
            </el-form-item>

            <el-form-item prop="operation_type">
                <CustomInput label='操作项'>
                    <SelectAll :options="defaultOptions['operation_type']"  v-model="formData.operation_type"/>
                </CustomInput>
            </el-form-item>

            <el-form-item prop="operation_target">
                <CustomInput @append-click="handleGenAppendClick(searchType, '输入或粘贴名称/ID，每行一个')">
                    <template #prepend>
                        <el-select
                            style="width:80px"
                            v-model="formData.search_type"
                            slot="prepend"
                            placeholder="请选择"
                            @change="handleType"
                        >
                            <el-option value="1" label="账户" ></el-option>
                            <el-option value="2" label="计划" ></el-option>
                            <el-option value="3" label="广告组" ></el-option>
                            <el-option value="4" label="广告" ></el-option>
                            <el-option value="5" label="创意" ></el-option>
                        </el-select>
                    </template>
                    <ESelect
                        v-model="formData.operation_target"
                        filterable
                        clearable
                        placeholder="请输入关键字搜索"
                        multiple
                        collapse-tags
                        remote
                        reserve-keyword
                        :loading="searchLoading"
                        ref="operation_target"
                        @visible-change="(val)=>handleVisibleChange(val, 'operation_target')"
                        :remote-method="(search) => appEntrySearchList(search, searchType)"
                        style="width: 250px;"
                    >
                        <p class="option-select">
                            <el-button type="text" @click="()=>handleSelectAll(operation_target_DataList, 'operation_target', 'all')">全选</el-button>
                            <el-button type="text" @click="()=>handleSelectAll(operation_target_DataList, 'operation_target', 'cancel')">取消全选</el-button>
                        </p>
                        <el-option
                            v-for="item in operation_target_DataList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        />
                    </ESelect>
                    <template #append>
                        <i class="el-icon-document-copy"/>
                    </template>
                </CustomInput>
            </el-form-item>

            <el-form-item prop="status">
                <CustomInput label='状态'>
                    <SelectAll :options="defaultOptions['status']" v-model="formData.status"/>
                </CustomInput>
            </el-form-item>
          
            <el-form-item prop="source_module">
                <CustomInput label='任务来源模块'>
                    <SelectAll :options="defaultOptions['source_module']" v-model="formData.source_module"/>
                </CustomInput>
            </el-form-item>
             <el-form-item prop="source_info">
                <CustomInput label='任务来源信息'>
                   <el-input v-model="formData.source_info" placeholder="请输入任务来源关键词" style="width:140px" clearable />
                </CustomInput>
            </el-form-item>
              <el-form-item prop="source_user">
                <CustomInput label='任务来源人'>
                    <SelectAll :options="defaultOptions['source_user']" v-model="formData.source_user"/>
                </CustomInput>
            </el-form-item>
            <el-form-item prop="creator">
                <CustomInput label='创建人'>
                    <SelectAll :options="defaultOptions['creator']" v-model="formData.creator"/>
                </CustomInput>
            </el-form-item>

            <el-form-item prop="range_time">
                <CustomInput label='创建时间'>
                    <el-date-picker
                        v-model="formData.range_time"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        prefix-icon=""
                        clearable
                        value-format="yyyy-MM-dd"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </CustomInput>
            </el-form-item>
        </el-form>
        <div class="opts">
            <el-button v-matomo="{behaviorCategory: '广告批量调控', event: '点击',  name: '查询'}" type="primary" size="mini" :loading="loading" @click="handleOnSubmit">查询</el-button>
            <el-button v-matomo="{behaviorCategory: '广告批量调控', event: '点击',  name: '清空筛选' }" size="mini" @click="resetForm()">清空筛选</el-button>
        </div>
    </div>
</template>

<script>

import CustomInput from '@/components/CustomInput'
import SelectAll from '@/components/SelectAll';
import {batchSelectModal} from "@/components/modal"
import API from "@/api/efficiencyTool/ads.js"
export default {
    name: 'storePage_query',
    components: {
        CustomInput,
        SelectAll
    },
    props:['query','loading', 'allowedPlatList', 'reload'],
    data() {
        return {
            defaultOptions:{
                plat:[],
                operation_level:[],
                operation_type:[],
                status:[],
                creator:[],
            },
            searchType: 'account',
            operation_target_DataList: [], //远程搜索计划
            // material_md5_DataList: [],
            // production_user_DataList: [],
            // director_DataList: [],
            // label_ids_DataList: [],
            formData: {
                task_id: '',  //任务ID
                operation_items: '', //操作内容
                plat_id: [],  //媒体
                operation_level: [],  // 操作层级
                operation_type: [], // 操作项
                search_type: '1', // 账户与计划
                status: [], //状态
                creator: [], //创建人
                range_time: [], //创建时间
                operation_target:[],
                source_user: [], // 来源用户
                source_module: [], // 来源模块
                source_info: '', // 来源信息
            },
            searchLoading:false,
            game_classify_disabled: false,
        }
    },
    watch:{
        'reload': {
            handler(n, o){
                if(n){
                    this.resetForm()
                    this.$emit('update:reload', false)
                }
            },
        },
    },
    mounted() {
        let query_id = this.query?.id
        if(query_id) {
            this.formData.task_id = query_id
            setTimeout(()=>{
                this.$router.replace({name: 'ad_batch_adjustment', query:{}})
            },100)
        }

        this.fetchGetSearchOther()
        this.handleOnSubmit()
    },
    methods:{
        //部分 远程搜索下拉枚举值
        fetchGetSearchOther() {
            let forArray = ['plat','creator', 'operation_level', 'operation_type', 'status', 'source_user', 'source_module']
            forArray.forEach((item)=>{
                API.postListSelectApi({search:'',batch_search:'',search_type: item},{cancel:false}).then(res=>{
                    const list = res.data.list || [];
                    this.defaultOptions[`${item}`]= list.map(v=> {
                        return {
                            ...v,
                            value: v.id,
                            label: v.name
                        }
                    })
                }, err=>{
                    this.$message.error(err.info)
                })
            })
        },
        // 重置form变量
        resetData(values) {
            if(Array.isArray(values)) {
                for (let key in this.formData) {
                    if (!values.includes(key)) {
                        this.formData[key] = null;
                    }
                }
            }
            this.fetchSetCustomFilter(values)
        },
        // 表单项 显示与隐藏
        handleType(value) {
            if(value == 1) {
                this.searchType = 'account'

            }else if(value == 2) {
                this.searchType = 'plan'
            }
            this.formData.operation_target = []
            this.operation_target_DataList = []
        },
        // 下拉检索
        async appEntrySearchList(search, type, p ={}, cb) {
            try {
                const params = {
                    search_type: type,
                    search,
                    ...p
                };
                this.searchLoading = true
                const { data } = await API.postListSelectApi(params);
                const list = data.list || [];
                const errList = data.err_list;
                if (params.batch_search) {
                    cb(errList, ()=> {
                        const ids = list.map(v=>v.id)
                        this.operation_target_DataList = [
                            ...this.operation_target_DataList.filter(v=>this.formData['operation_target'].includes(v.value)&&!ids.includes(v.value)),
                            ...list.map(v=> {
                                return {
                                    ...v,
                                    value: v.id,
                                    label: v.name
                                }
                            })
                        ]
                        this.formData.operation_target = [...new Set([ ...this.formData.operation_target, ...ids ])];
                    })
                }else {
                    this.operation_target_DataList= list.map(v=> {
                        return {
                            ...v,
                            value: v.id,
                            label: v.name
                        }
                    })
                }
            } catch (error) {
                console.log(error, '-----');
                this.$message.warning(error.info)
            } finally {
                this.searchLoading = false
            }
        },

        handleGenAppendClick(type, placeholder) {
            const onSubmit = (data, callback)=> {
                if (!data.length) {
                    this.$message.error('请输入内容');
                    callback()
                    return;
                };
                this.appEntrySearchList(
                    '',
                    type,
                    {
                        batch_search: data,
                    },
                    (errs, cb)=> {
                        callback();
                        if (errs.length) {
                            delErrList({
                                tip: '未找到以下数据信息，请核实，是否需要剔除未找到的?',
                                list: errs,
                                onOk: ()=> {
                                    cb();
                                    vm.close();
                                }
                            })
                        }else {
                            cb();
                            vm.close();
                        }
                    }
                )
            }
            const { vm, delErrList } = batchSelectModal({
                title: '批量添加',
                props: {
                    tip: placeholder ? placeholder : '输入或粘贴名称或ID，每行一个',
                    hasLoading: true
                },
                cbs: {
                    onSubmit
                }
            })
        },
        handleVisibleChange(visible, type) {
            if (visible) {
                const options = this.$refs[type].selected|| [];
                const listData = options.map(v=> {
                    return v.$options.propsData
                });
                this.$set(this, `${type}_DataList`, listData)
            }
        },
        handleSelectAll(list, type, selectType) {
            if(selectType === 'all') {
                const data = [...(this.formData[type] || [])];
                data.push(...list.map(v=>v.value));
                // 去重 赋值
                this.formData[type] = [ ...new Set(data)]
            }else{
                let optionList_ids = this[`${type}_DataList`].map(item=>item.value)
                let channel_ids = this.formData[type].filter(item=> !optionList_ids.includes(item))
                this.formData[type] = [...channel_ids]
            }
        },
        handleOnSubmit() {
            let params = {}
            for (let key in this.formData) {
                params[key] = this.formData[key]
            }
            let res_range_time = this.formData.range_time ? this.formData.range_time.join('/') : ''; //时间的格式处理

            params['range_time'] = res_range_time

            // if(Object.keys(this.$route.query).length != 0) {
            //     this.$router.push({name:'material', query:{}})
            // }
            this.$emit('query-click', params)
        },
        //清空
        resetForm() {
            this.$refs['formInline'].resetFields();
            this.formData.task_id = ''
            this.formData.operation_items = ''
            this.formData.plat_id = []
            this.formData.operation_level = []
            this.formData.operation_type = []
            this.formData.search_type = '1'
            this.formData.status = []
            this.formData.creator = []
            this.formData.range_time = []
            this.formData.operation_target = []
            this.formData.source_user = []
            this.formData.source_module = []
            this.formData.source_info = ''

            this.$nextTick(()=>{
                this.handleOnSubmit()
            })
        },
    }
}
</script>
<style lang="scss" scoped>
.opts {
    border-top: 1px solid #ccc;
    padding-top: 10px;
}
.form-box {
    background: #ffffff;
    padding: 20px 10px;
    border-radius: 4px;
    &::v-deep {
        .el-form-item {
            margin-bottom: 10px;
        }
    }
}
.table-context {
    background-color: #fff;
    margin-top: 12px;
    border-radius: 4px;
    padding-top: 12px;
}
.storeFlex{
    display: inline-flex;
    width: 220px;
    align-items: center;
    overflow: hidden;
}
</style>

